document.querySelectorAll('.testimonial-section').forEach((ts) => {
    const testimonialSlides = ts.getElementsByClassName('testimonial-slide');
    const slideLength = testimonialSlides.length - 1;
    const next = ts.querySelector('.testimonial-section .next-slide i');
    const previous = ts.querySelector('.testimonial-section .previous-slide i');
    const slideTime = 9000;
    let slideTimer;
    let active;
    let nextActive;
    let translate = 0;

    function changeSlide(slideDirection) {
        clearInterval(slideTimer);
        next.style.pointerEvents = 'none';
        previous.style.pointerEvents = 'none';
        setTimeout(function () {
            next.style.pointerEvents = 'auto';
            previous.style.pointerEvents = 'auto';
        }, 500);
        active = ts.querySelector('.active-testimonial');
        if (slideDirection === 'forward') {
            nextActive = active.nextElementSibling
                ? active.nextElementSibling
                : testimonialSlides[0];
            translate = translate === slideLength * -100 ? 0 : translate - 100;
        } else {
            nextActive = active.previousElementSibling
                ? active.previousElementSibling
                : testimonialSlides[slideLength];
            translate = translate === 0 ? slideLength * -100 : translate + 100;
        }
        translateSlides();
        active.style.opacity = '0';
        setTimeout(function () {
            active.classList.remove('active-testimonial');
            nextActive.classList.add('active-testimonial');
            nextActive.style.opacity = '0';
        }, 300);
        setTimeout(function () {
            nextActive.style.opacity = '1';
        }, 450);
        slideTimer = setInterval(function () {
            changeSlide('forward');
        }, slideTime);
    }

    function translateSlides() {
        setTimeout(() => {
            ts.querySelectorAll('.testimonial-slide').forEach((slide) => {
                slide.style.transform = 'translateX(' + translate + '%)';
            });
        }, 250);
    }

    if (next) {
        next.addEventListener('click', function () {
            changeSlide('forward');
        });
    }

    if (previous) {
        previous.addEventListener('click', function () {
            changeSlide('backward');
        });
    }

    if (slideLength > 0) {
        slideTimer = setInterval(function () {
            changeSlide('forward');
        }, slideTime);
    }
});



// WEBPACK FOOTER //
// ./app/js/modules/testimonial-slider.js